/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Light_AircraftInputs */

const en_val_light_aircraft = /** @type {(inputs: Val_Light_AircraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light Aircraft`)
};

const es_val_light_aircraft = /** @type {(inputs: Val_Light_AircraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avioneta`)
};

const fr_val_light_aircraft = /** @type {(inputs: Val_Light_AircraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avion léger`)
};

const de_val_light_aircraft = /** @type {(inputs: Val_Light_AircraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leichtflugzeug`)
};

const ja_val_light_aircraft = /** @type {(inputs: Val_Light_AircraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`軽航空機`)
};

const zh_val_light_aircraft = /** @type {(inputs: Val_Light_AircraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轻型飞机`)
};

const ar_val_light_aircraft = /** @type {(inputs: Val_Light_AircraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طائرة خفيفة`)
};

const id_val_light_aircraft = /** @type {(inputs: Val_Light_AircraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesawat Ringan`)
};

const it_val_light_aircraft = /** @type {(inputs: Val_Light_AircraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velivolo Leggero`)
};

const ru_val_light_aircraft = /** @type {(inputs: Val_Light_AircraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Легкий самолет`)
};

const pt_val_light_aircraft = /** @type {(inputs: Val_Light_AircraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aeronave Leve`)
};

const ko_val_light_aircraft = /** @type {(inputs: Val_Light_AircraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경비행기`)
};

/**
* | output |
* | --- |
* | "Light Aircraft" |
*
* @param {Val_Light_AircraftInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_light_aircraft = /** @type {((inputs?: Val_Light_AircraftInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Light_AircraftInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_light_aircraft(inputs)
	if (locale === "es") return es_val_light_aircraft(inputs)
	if (locale === "fr") return fr_val_light_aircraft(inputs)
	if (locale === "de") return de_val_light_aircraft(inputs)
	if (locale === "ja") return ja_val_light_aircraft(inputs)
	if (locale === "zh") return zh_val_light_aircraft(inputs)
	if (locale === "ar") return ar_val_light_aircraft(inputs)
	if (locale === "id") return id_val_light_aircraft(inputs)
	if (locale === "it") return it_val_light_aircraft(inputs)
	if (locale === "ru") return ru_val_light_aircraft(inputs)
	if (locale === "pt") return pt_val_light_aircraft(inputs)
	return ko_val_light_aircraft(inputs)
});